import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-privacy',
  imports: [RouterLink],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.sass'
})
export class PrivacyComponent {
  readonly contactEmail = environment.contactEmail;
  readonly siteOwnerName = environment.siteOwnerName;
  readonly lastUpdated = '2026-04-02';
}
